import { defaultThemeProp, tryCatch } from '@pega/cosmos-react-core';
import BareButton from '@pega/cosmos-react-core/lib/components/Button/BareButton';
import { rgba } from 'polished';
import styled, { css } from 'styled-components';

import { ColorBgProp } from '../SocialMedia/Chat/Tabs/ChatPreview/TextMessage';

export const StyledMessageBubbleContent = styled.div``;

export const StyledMediaList = styled.ul``;

export const StyledMediaListItem = styled.li``;

export const StyledSummaryItem = styled.div``;

export const StyledMediaThumbNail = styled.img``;

export const StyledMediaDownloadButton = styled.button``;

export const StyledMediaLink = styled.a``;

export const StyledMediaButton = styled(BareButton)``;

export const StyledMessageMain = styled.div``;

export const StyledMessageBubble = styled.div``;

export const StyledMetaInfoContainer = styled.div``;

export const StyledMetaInfo = styled.span``;

export const StyledTypingIndicator = styled.div``;

export const StyledMessageHeader = styled.header``;
export const StyledMessageHeaderContent = styled.div``;
export const StyledMessageHeaderMeta = styled.div``;

interface StyledMessageContainerProps {
  variant: 'sender' | 'receiver' | 'other';
  messageDirection: 'in' | 'out' | string;
  typing: boolean;
}

export const StyledMessageContainer = styled.div<StyledMessageContainerProps>(
  ({
    messageDirection,
    variant,
    typing,
    theme,
    theme: {
      base: {
        palette: { 'foreground-color': foregroundColor, 'secondary-background': secondaryBackground },
        transparency: { 'transparent-2': foregroundAlpha },
      },
      components: { button },
    },
  }) => {
    const messageHeaderTheme = theme.components.chat.messageBubble[variant].header;
    const messageContentTheme = theme.components.chat.messageBubble[variant].content;
    const padding = messageDirection === 'in' ? '0 2rem 0 0' : '0 0 0 2rem';
    const metaForegroundColor = tryCatch(() => rgba(foregroundColor, foregroundAlpha));

    return css`
      padding: ${padding};
      margin-bottom: ${typing ? '0.5rem' : '0'};
      ${StyledMessageMain} {
        max-width: 90%;
      }
      ${StyledMessageBubble} {
        max-width: 100%;
        min-width: 100%;
        background: ${messageContentTheme['background-color']};
        border-radius: calc(3 * ${theme.base['border-radius']}) ${theme.base['border-radius']}
          calc(3 * ${theme.base['border-radius']}) calc(3 * ${theme.base['border-radius']});
        overflow: hidden;
        color: ${messageContentTheme['foreground-color']};
        display: inline-block;
        width: auto;
        margin-bottom: 0.25rem;

        label {
          color: inherit;
        }

        ${messageDirection === 'in' &&
        css`
          border-radius: ${theme.base['border-radius']} calc(3 * ${theme.base['border-radius']})
            calc(3 * ${theme.base['border-radius']}) calc(3 * ${theme.base['border-radius']});
        `}

        > ${StyledMessageBubbleContent} {
          padding: 0.5rem 1rem;
          word-break: break-word;
          white-space: pre-wrap;
          position: relative;
        }

        > ${StyledMediaList} {
          color: ${messageContentTheme['foreground-color']};
          max-width: 100%;

          ${StyledMediaDownloadButton} {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            color: ${messageContentTheme['foreground-color']};
            width: ${button.height};
            height: ${button.height};
            border: 0.0625rem solid transparent;
            &:enabled:hover,
            &:enabled:focus {
              background: ${messageContentTheme['background-color']};
              color: ${messageContentTheme['foreground-color']};
              border: 0.0625rem solid ${messageContentTheme['foreground-color']};
              border-radius: 50%;
            }
            svg {
              width: 50%;
              height: 50%;
            }
          }

          > ${StyledMediaListItem} {
            position: relative;
            ${StyledMediaThumbNail} {
              max-height: 12rem;
              width: 100%;
              object-fit: contain;
              background-color: ${secondaryBackground};
            }
            ${StyledSummaryItem} {
              padding: 0.5rem 1.5rem;
              font-size: 0.75rem;
              margin-top: 0.25rem;
            }
            ${StyledSummaryItem}::before {
              content: '';
              padding: 0.5rem 0;
              border-top: 0.0625rem solid ${messageContentTheme['foreground-color']};
              position: absolute;
              width: calc(100% - 2rem);
              left: 1rem;
              top: 0;
            }
            ${StyledMediaThumbNail} + ${StyledSummaryItem}::before {
              content: none;
            }
            svg {
              font-size: 1.6rem;
            }
          }
        }

        ${StyledMessageHeader} {
          padding: 0.5rem 1rem;
          color: ${messageHeaderTheme['foreground-color']};
          background-color: ${messageHeaderTheme['background-color']};
        }

        ${StyledMessageHeaderContent} {
          color: ${messageHeaderTheme['foreground-color']};
          margin-inline-end: ${theme.base.spacing};
        }
        ${StyledMessageHeaderMeta} {
          > a {
            color: ${messageHeaderTheme['foreground-color']};
          }
        }

        ${StyledMediaLink}, ${StyledMediaButton} {
          color: ${messageContentTheme['foreground-color']};
          font-size: inherit;
          text-decoration: none;
          font-weight: 700;
          overflow-x: hidden;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          display: inline-block;
          max-width: 100%;
          &:hover {
            color: ${messageContentTheme['foreground-color']};
            text-decoration: underline;
          }
          &:visited {
            color: ${messageContentTheme['foreground-color']};
          }
          &:focus {
            box-shadow: ${theme.base.shadow.focus};
          }
        }
      }

      ${StyledMetaInfoContainer} {
        width: 100%;
        padding: 0 0.5rem;
        ${StyledMetaInfo} {
          margin-bottom: 0.5rem;
          font-size: 0.7rem;
          color: ${metaForegroundColor};
        }
      }
      ${StyledTypingIndicator} {
        width: 4.5rem;
        position: relative;
        height: 2rem;
      }
    `;
  },
);
StyledMessageContainer.defaultProps = defaultThemeProp;
interface StyledBlinkingDotProps {
  delay?: number;
}

export const StyledBlinkingDot = styled.div<StyledBlinkingDotProps>(({ delay = 0, theme }) => {
  return css`
    @keyframes Blinking {
      0% {
        background: ${theme.base.colors.gray.medium};
      }
      100% {
        background: ${theme.base.colors.gray['extra-light']};
      }
    }
    animation: Blinking calc(4 * ${theme.base.animation.speed}) infinite;
    background: ${theme.base.colors.gray['extra-light']};
    border-radius: 50%;
    animation-delay: ${delay}s;
    height: 0.4rem;
    width: 0.4rem;
  `;
});
StyledBlinkingDot.defaultProps = defaultThemeProp;

export const csrChatContentStyle = styled.div(
  (props: ColorBgProp) =>
    css`
      padding: 6px 12px 6px 12px;
      max-width: 210px;
      background-color: ${props.bgColor ? props.bgColor : '#e9ebef'};
      color: ${props.color};
      border-radius: 16px 16px 16px 4px;
      overflow-wrap: break-word;
    `,
);

export const cxChatAvatarStyle = styled.div(
  (props: ColorBgProp) =>
    css`
      padding: 6px 12px 6px 12px;
      max-width: 210px;
      background-color: ${props.bgColor ? props.bgColor : '#e9ebef'};
      color: ${props.color};
      border-radius: 16px 16px 4px 16px;
      overflow-wrap: break-word;
    `,
);

export const cxChatContentStyle = styled.div(
  (props: ColorBgProp) =>
    css`
      padding: 10px 16px 10px 16px;
      max-width: 210px;
      background-color: ${props.bgColor ? props.bgColor : '#e9ebef'};
      color: ${props.color};
      border-radius: 16px 16px 4px 16px;
      overflow-wrap: break-word;
    `,
);
